module.exports = __webpack_public_path__ + "img/微信3.2e047f00.png";